/* istanbul ignore file */
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const MirrorFileResultParser = /* #__PURE__ */ parsers.object([
    ['url', codecString],
    ['name', codecString],
    ['outputName', codecString, 'output_name'],
    ['mime', /* #__PURE__ */ parsers.maybeNull(codecString)],
]);
export class MirrorFileResult extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return MirrorFileResultParser.decode(input).map(res => new MirrorFileResult(res));
    }
    static unsafeDecode(input) {
        return MirrorFileResult.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return MirrorFileResultParser.encode(data);
    }
    static schema() {
        return MirrorFileResultParser.schema();
    }
}
